import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import firebase from './Fireb';
import { Link } from 'react-router-dom';

import Title from "./Title";
import styled from "styled-components";
import { ButtonContainer, ButtonContainer2 } from './Button'
import {storage} from "./Fireb"
import { FaWindows } from 'react-icons/fa';
import logo from '../aplogo.png'
export default class Add extends Component {

  constructor() {
    super();
    this.ref = firebase.firestore().collection('storeProducts');
    this.state = {
      company: '',
      info: '',
      price: '',
      title: '',
      total: 0,
      incart: false,
      count: 0,
      img: null,
      url: '',
      progress: 0,
      btn:true,
      btn2:true,
      vid: ''
    };
    this.ShowAlertWithDelay = this.ShowAlertWithDelay.bind(this);
   // this.setTimeout = this.setTimeout.bind(this);
  }
  handleChange2 = (e) => {
    if (e.target.files[0]) {
      const img = e.target.files[0];
      this.setState(() => ({img,btn:false,btn2:false}));
      
    }
  }
  ShowAlertWithDelay(){
    
     setTimeout(function(){
      //this.props.history.push("/")
      window.location.assign('/');
  
       //Put All Your Code Here, Which You Want To Execute After Some Delay Time.
      // Alert.alert("Alert Shows After 5 Seconds of Delay.")
   
     }, 2000);}
   

      
   uploadPhotoAsync = (uri, filename) => {
    
    this.setState(() => ({btn:true}));
       return new Promise(async (res, rej) => {
           const response = await fetch(uri);
           const file = await response.blob();

           
               const {img} = this.state;
             
               const uploadTask = storage.ref(`images/${img.name}`).put(img);
           uploadTask.on(
               "state_changed",
               snapshot => { 
                   const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                  this.setState({progress});},
               err => {
                   rej(err);
               },
               async () => {
                   const url = await uploadTask.snapshot.ref.getDownloadURL();
                   
                   res(url);
               }
           );
       });
   };

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);
  }









  createUser = async user => {
    let remoteUri = null;

    try {
        await firebase.auth().createUserWithEmailAndPassword(user.email, user.password);

        let db = this.firestore.collection("users").doc(this.uid);

        db.set({
            name: user.name,
            email: user.email,
            avatar: null
        });

        if (user.avatar) {
            remoteUri = await this.uploadPhotoAsync(user.avatar, `avatars/${this.uid}`);

            db.set({ avatar: remoteUri }, { merge: true });
        }
    } catch (error) {
        alert("Error: ", error);
    }
};











uploadPhotoAsync2 = (uri, filename) => {
  return new Promise(async (res, rej) => {
      const response = await fetch(uri);
      const file = await response.blob();

      let upload = firebase
          .storage()
          .ref(filename)
          .put(file);

      upload.on(
          "state_changed",
          snapshot => {},
          err => {
              rej(err);
          },
          async () => {
              const url = await upload.snapshot.ref.getDownloadURL();
              res(url);
          }
      );
  });
};







  onSubmit =  async e => {
   e.preventDefault();
  
    //console.log(this.state.image, this.state.remoteUri)
  //  const remoteUri = await this.uploadPhotoAsync();
    
  //  this.setState({remoteUri});

   // return new Promise((res, rej) => {
    let remoteUri = null;

    try {

       // let db = this.firestore.collection("storeP")
        const { company,info, incart,price,title,total,img,count, vid} = this.state;
        this.ref.add({
          company,
          info,
           incart,
           price: parseInt(price) ,
           title,total, 
           img: 'https://static.vecteezy.com/system/resources/thumbnails/000/375/499/small/Basic_Elements__28128_29.jpg',
           count,vid: firebase.auth().currentUser.uid
           
        }
        )
     
        if (img) {
          e.preventDefault()
            remoteUri = await this.uploadPhotoAsync();
        //  console.log(remoteUri)
          //  this.ref.set({ img: remoteUri });
            this.ref.get().then(doc => {
              if(!doc.empty){
                e.preventDefault();
                doc.forEach((doc) => {
              const vendorPay = doc.data();
              const collection = firebase.firestore().collection('storeProducts')    
                  const newDocumentBody = {
                    img: remoteUri
                  }
                  collection.where("company", "==", this.state.company).where("title", "==", this.state.title).where("img", "==", 'https://static.vecteezy.com/system/resources/thumbnails/000/375/499/small/Basic_Elements__28128_29.jpg').get().then(response => {
                      let batch = firebase.firestore().batch()
                      response.docs.forEach((doc) => {
                        e.preventDefault()
                          const docRef = firebase.firestore().collection('storeProducts').doc(doc.id)
                          batch.update(docRef, newDocumentBody)
                      })
                      batch.commit().then(() => {
                        window.location.assign('/');
                      })
                  });
                })
            }
        })
    } else {
      this.ShowAlertWithDelay();
    }
  } 
  
    catch (error) {
        console.log("Error: ", error);
    }
      
  }
  render() {
    const { company,info, incart,price,title,total,img,count } = this.state;
   // const { title, price } = this.state;
    return (

      
        <React.Fragment>
            <ProductWrapper className="py-5">
              <div className="container">
                <Title name="Create" title="Product" />
      <div class="container">
        <div class="panel panel-default">
        


          
            <form onSubmit={this.onSubmit}>
              <div class="form-group">
                <label for="title">Product Name:</label>
                <input type="text" class="form-control" name="title" value={title} onChange={this.onChange} placeholder="Product Name" required/>
              </div>
              <div class="form-group">
                <label for="company">Company:</label>
                <input type="text" class="form-control" name="company" value={company} onChange={this.onChange} placeholder="Company" required/>
              </div>
              <div class="form-group">
                <label for="price">Price:</label>
                <input type="number" class="form-control" name="price"  value={price} onChange={this.onChange} placeholder="Price" required/>
              </div>
              <div class="form-group">
                <label for="info">Short Info:</label>
                <input type="text" class="form-control" name="info" value={info} onChange={this.onChange} placeholder="Short Info" required/>
              </div>
              <div>
        <progress value={this.state.progress} max="100"/>
        <br/>
          <input type="file" onChange={this.handleChange2}/>
          <br/>
          
        </div>

            <ButtonContainer2><button hidden type="submit" class="btn btn-success" onClick={this.onSubmit}>f</button>Create</ButtonContainer2>  
            </form>
          






        </div>
      </div>
      </div>
        </ProductWrapper>
      </React.Fragment>




    );
  }
}
const ProductWrapper = styled.section``;
/*onSubmit = (e) => {
  e.preventDefault();

  const { title, price, info } = this.state;

  this.ref.add({
    title,
   price: parseInt(price),
    info
  }).then((docRef) => {
    this.setState({
      title: '',
      price: '',
      info: ''
    });
    this.props.history.push("/")
  })
  .catch((error) => {
    console.error("Error adding document: ", error);
  });
}*/

/*createUser = async user => {
  let remoteUri = null;

  try {
      await firebase.auth().createUserWithEmailAndPassword(user.email, user.password);

      let db = this.firestore.collection("users").doc(this.uid);

      db.set({
          name: user.name,
          email: user.email,
          avatar: null
      });

      if (user.avatar) {
          remoteUri = await this.uploadPhotoAsync(user.avatar, `avatars/${this.uid}`);

          db.set({ avatar: remoteUri }, { merge: true });
      }
  } catch (error) {
      alert("Error: ", error);
  }
};*/